<div class="modal-body">
    <patient-dashboard #pd [patientId]="patientId" [patient]="patient" [wrid]="wrId" [wruid]="wruId"></patient-dashboard>
</div>
